import Modal from "react-bootstrap/Modal";
import { Button, Card } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import GalleryModal from "../Common/Modal/GalleryModal";
import { useState } from "react";
export const VideoInstruction = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Steps for Video Url
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Accordion defaultActiveKey="0">
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey="0">
                Step 1
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <a href="/tv" className="btn-link" target="_blank">
                  Go to Tv Module
                </a>
                <img
                  onClick={() => setIsOpen(true)}
                  src="https://danzflomusic2.s3.us-east-2.amazonaws.com/tv1.png"
                />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey="1">
                Step 2
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="1">
              <Card.Body>
                <p>
                  Then Click on Videos and open the video and get the url Embed
                  Iframe!
                </p>

                <img src="https://danzflomusic2.s3.us-east-2.amazonaws.com/image_2022_12_19T10_52_06_423Z.png" />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};
